export default __webpack_public_path__ + "static/media/bg-login.c4a24bde.jpg";